// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2QPTr","col":"styles_col__1pua1"};